import { Component } from '@angular/core';

@Component({
    selector: 'cmps-coaching-legend-item',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-coaching-legend-item',
    },
})
export class CmpsLegendItemComponent {}
